import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { LanguageCode } from '@/types/enum'

import enUsTrans from './en-us.json'
import zhCnTrans from './zh-cn.json'
import { languageMap } from '@/utils'
let currentLang = localStorage.getItem('i18nextLng');
if(!languageMap[currentLang]) {
  currentLang = ''
  localStorage.removeItem('i18nextLng');
}

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false
  }
  type TFunctionResult = string
}

i18n
  .use(initReactI18next) // init i18next
  .init({
    // 引入资源文件
    resources: {
      [LanguageCode.En]: {
        translation: enUsTrans,
      },
      [LanguageCode.ZhCn]: {
        translation: zhCnTrans,
      },
    },
    lng: currentLang || undefined,
    // 选择默认语言，选择内容为上述配置中的key，即en/zh
    fallbackLng: currentLang || LanguageCode.ZhCn,
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    returnNull: false,
    lowerCaseLng: true,
  }).then(()=>{
    i18n.on('languageChanged', (lng) => {
      localStorage.setItem('i18nextLng', lng)
    })
  })

export default i18n
